import React from 'react';
//CSS
import styles from './DataSources.module.css';
import format from '../Formats.module.css'
//Components
//Data

type DataSourcesProps = {
    sources?: string[];
    children?: React.ReactNode;
};

const DataSources = ({ sources, children } : DataSourcesProps) => {
  return (
    <div>
        {children}
        <section className={styles.section}>
            <div className={`${styles.header} ${styles.dataSourcesHeader}`}>
                {/*<h4 className={styles.font}>Data Sources</h4>
                <ul>
                    {sources?.map((source, areaIndex) => (
                        <li className={format.pill} key={areaIndex}>{source}</li>
                    ))}
                </ul>*/}
            </div>
        </section>
    </div>

    
  );
};

export default DataSources;